import Breadcrumbs from "../../../components/breadcrumbs";
import ExerciseCategoryCreateForm from "./ui/ExerciseCategoryCreateForm";

export default function ExerciseCategoryCreatePage() {
  return (
    <main className="max-w-3xl ">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Exercise Categories", href: "/admin/exercise-categories" },
          {
            label: "create",
            href: `/admin/exercise-categories/Create`,
            active: true,
          },
        ]}
      />

      <ExerciseCategoryCreateForm />
    </main>
  );
}
